var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgPin = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8376 6.10953L25.8899 11.1618C26.455 11.727 26.737 12.5158 26.6583 13.3111C26.5795 14.1065 26.1483 14.8246 25.4833 15.268L21.8083 17.718C21.2561 18.0861 20.861 18.6468 20.7 19.2906L19.1079 25.6589C18.9914 26.1251 18.633 26.4926 18.1699 26.6208C17.7068 26.7491 17.2105 26.6184 16.8707 26.2786L5.72075 15.1286C5.38097 14.7888 5.25024 14.2925 5.37851 13.8294C5.50678 13.3663 5.87423 13.008 6.34042 12.8914L12.7088 11.2994C13.3526 11.1385 13.9133 10.7433 14.2814 10.1911L16.7314 6.51613C17.1748 5.8511 17.8929 5.41988 18.6883 5.34112C19.4837 5.26237 20.2724 5.54437 20.8376 6.10953Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2947 20.7051L5.32812 26.6717",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2214 18.2546L13.748 10.7812",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPin, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/pin.0abb894c.svg";
export { ForwardRef as ReactComponent };